import { createFileRoute } from "@tanstack/react-router";
import { searchParams } from "@/pages/admin-sourcing-overview/model/search-params";
import { SourcingOverviewPage } from "@/pages/admin-sourcing-overview/ui/sourcing-overview-page";

export const Route = createFileRoute(
  "/_authed/$companySlug/admin/sourcing/overview/",
)({
  component: SourcingOverviewPage,
  validateSearch: searchParams,
});
